import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { CONTACT_AN_AGENT } from "../api/constants";
import Swal from 'sweetalert2';


function ContactAgentModal({ show, handleClose, property_id, preferred_move_in_date, message, listing_type, agent_id, agent_name }) {
  const user = JSON.parse(localStorage.getItem("user"))
  const token = localStorage.getItem("token");
  console.log("client user", user)
  let user_id = null;
  if (user?.role == "client") {
    user_id = user.id
  }

  const isLoggedIn = !!(user && token);

  const initialFormData = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    message: message || "",
    wants_financing_info: false,
    property_id: property_id,
    preferred_move_in_date: preferred_move_in_date,
    inquiry_type: property_id ? 'property' : 'general',
    agent_id: agent_id ? agent_id : '',
    user_id: user_id
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      agent_id: agent_id || '',
      property_id: property_id,
      preferred_move_in_date: preferred_move_in_date,
      message: message || '',
      inquiry_type: property_id ? 'property' : 'general',
    }));
  }, [agent_id, property_id, preferred_move_in_date, message]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Prefill user details from profile when logged in
  useEffect(() => {
    if (!isLoggedIn || !user) return;

    setFormData(prev => ({
      ...prev,
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      email: user.email || '',
      phone: user.phone_number || '',
    }));
  }, [isLoggedIn]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData)
    try {
      const res = await fetch(CONTACT_AN_AGENT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify({
          ...formData,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to submit viewing request");
      }

      if (data.status) {
        Swal.fire({
          title: 'Success!',
          text: data.message,
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#0abab5'
        });
        setFormData(initialFormData)
      }
      handleClose();
    } catch (err) {
      console.error("Viewing request error:", err.message);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      scrollable
      className="contact-agent-modal"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>
          {listing_type === "sale"
            ? "Contact a Buyer's Agent"
            : listing_type === "rent"
              ? "Contact a Rental Agent"
              : agent_name
                ? `Contact Agent ${agent_name}`
                : "Contact An Agent"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>

          {/* Only show name/email/phone fields when NOT logged in */}
          {!isLoggedIn && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>
                  First Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="first_name"
                  placeholder="Enter your first name"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Last Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="last_name"
                  placeholder="Enter your last name"
                  value={formData.last_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Email Address <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter email address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Phone Number <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="tel"
                  name="phone"
                  placeholder="Enter your number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </>
          )}

          {/* Always shown */}
          <Form.Group className="mb-3">
            <Form.Label>
              Message <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="message"
              placeholder="Write here..."
              value={formData.message}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Check
              type="checkbox"
              id="financing-checkbox"
              name="wants_financing_info"
              label="I want financing information"
              checked={formData.wants_financing_info}
              onChange={handleChange}
              className="custom-checkbox-modal custom-checkbox primary"
            />
          </Form.Group>

          <Button type="submit" className="w-100 custom-bttn style-3 btn-contact-agent">
            Contact an Agent
          </Button>

          <p className="disclaimer-text">
            By pressing Contact an agent, you agree that Real Estate Group and its affiliates,
            and real estate professionals may call/text you about your inquiry, which may
            involve use of automated means and prerecorded/artificial voices. You don't
            need to consent as a condition of buying any property, goods or services.
            Message/data rates may apply. You also agree to our Terms of Use. Real Estate
            does not endorse any real estate professionals. We may share information about
            your recent and future site activity with your agent to help them understand what
            you're looking for in a home.
          </p>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default ContactAgentModal;